import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getDashboardData } from "../../api/dashboard";

const initialState = {};

export const DashboardSlice = createSlice({
  name: "area",
  initialState,
  reducers: {
    list: (state, action) => {
      state.list = action.payload;
    }
  },
});

export const { list} = DashboardSlice.actions;

export const dashboardDataSelector = (state) => state.area.list;

export const FetchDashboardData = createAsyncThunk(
  "FetchDashboardData",
  async (obj, { dispatch }) => {
    try {
      const response = await getDashboardData(obj);
      if (response?.code === 1) {
        dispatch(list(response?.data));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export default DashboardSlice.reducer;
